import { BusyWatcher, ScreenBase } from "@frui.ts/screens";
import { computed, observable } from "mobx";
import { Modules } from "config";
import Month from "../../../entities/month";
import type ReportRepository from "../../../repositories/reportRepository";
import type LocalizationService from "../../../services/localizationService";
import type MonthOptionsService from "../../../services/monthOptionsService";

export default abstract class ReportsViewModel extends ScreenBase {
  abstract onDownloadClick(month: Month, ...rest: any): void;
  @observable selectedDate?: Date;
  busyWatcher = new BusyWatcher();

  @computed
  get selectedMonth() {
    if (this.selectedDate) {
      return new Month(this.selectedDate);
    }
    return undefined;
  }

  @computed
  get months() {
    return this.monthOptionsService.startOfMonthOptions;
  }

  constructor(
    protected localizationService: LocalizationService,
    protected repository: ReportRepository,
    protected monthOptionsService: MonthOptionsService
  ) {
    super();
    this.navigationName = "";
    this.selectedDate = this.months[0].id;
  }

  translate(code: string) {
    return this.localizationService.translateModule(Modules.finance, `expensesAndRevenuesReports.${code}`);
  }
}
